import React, {
  ReactElement,
  useEffect,
  useRef,
  useState,
  Fragment, useMemo,
} from 'react';
import Tooltip from '@mui/material/Tooltip';
import { formatNumber } from '../../../reducer/actions/formatNumber';
import Box from '@mui/material/Box';

export const PriceWithCurrencyCell = ({
  props,
}: {
  props: any;
}): ReactElement => {
  const divRef = useRef(null);
  const [tooltip, setTooltip] = useState(false);

  const transformedValue = props;

  function getDivWidth(divRef: any) {
    if (divRef && divRef.current) {
      const divElement = divRef.current;
      const parentElement = divElement.parentNode;

      const divRect = divElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      return {
        element: divRect.width,
        cell: parentRect.width,
      };
    }
    return {
      element: 0,
      cell: 0,
    };
  }

  useEffect(() => {
    setTooltip(false);
    const divWidth: { element: number; cell: number } = getDivWidth(divRef);

    if (divWidth['element'] > divWidth['cell']) {
      setTooltip(true);
    }
  });

  const value = useMemo(()=>{
    const items = [];

    if (props?.value?.value){
      let price = formatNumber(props?.value?.value);
      const pp = formatNumber(props?.value?.value_pp);
      if (pp){
        price = `${price} (${pp})`;
      }
      items.push(price);
    }

    if (props?.value?.currency?.name){
      items.push(props?.value?.currency?.name);
    }

    return items.join(" ");
  },[props]);

  if (!props?.value?.value) {
    return <></>;
  }

  return (
    <Box
      ref={divRef}
      className={`whitespace-nowrap ${
        tooltip ? 'has-tooltip' : 'doesnthave-tooltip'
      }`}
      sx={{
        lineHeight: '14px',
      }}
    >
      {tooltip ? (
        <>
          <Tooltip
            disableInteractive
            title={formatNumber(props?.value.value)}
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '13px',
                },
              },
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
            <span>
              {value}
            </span>
          </Tooltip>
        </>
      ) : (
        <>
          <span>
            {value}
          </span>
        </>
      )}
    </Box>
  );
};
